import { canUseDOM } from './dom';

export default function addOriginToUrl(url) {
  if (!url) return '';
  if (url.startsWith('http')) return url;

  return canUseDOM() ? `${window.location.origin}${url}` : url;
}
